

export const frontMatter = {
	sidebar_position: 3,
	license: 'republish',
	author: 'Jan van Steenbergen',
	origin: 'http://steen.free.fr/interslavic/phonology.html'
};
export const contentTitle = 'Фонология';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-i-18-n-bg-docusaurus-plugin-content-docs-current-learn-phonology-md-775.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Инвентаризация на фонемите",
  "id": "phoneme-inventory",
  "level": 2
}, {
  "value": "Гласни",
  "id": "vowels",
  "level": 2
}, {
  "value": "съгласни",
  "id": "consonants",
  "level": 2
}, {
  "value": "Твърди и меки съгласни",
  "id": "hard-and-soft-consonants",
  "level": 2
}, {
  "value": "Фонотактика",
  "id": "phonotactics",
  "level": 2
}, {
  "value": "Морфофонемични редувания",
  "id": "morphophonemic-alternations",
  "level": 2
}, {
  "value": "Палатализация",
  "id": "palatalisation",
  "level": 3
}, {
  "value": "Йотация",
  "id": "iotation",
  "level": 3
}, {
  "value": "Палатализация + йотация",
  "id": "palatalisation--iotation",
  "level": 3
}, {
  "value": "Общ преглед",
  "id": "overview",
  "level": 4
}, {
  "value": "O &gt; E",
  "id": "o--e",
  "level": 3
}, {
  "value": "Y &gt; I/E",
  "id": "y--ie",
  "level": 4
}, {
  "value": "<code>Ě &gt; I</code>",
  "id": "ě--i",
  "level": 4
}, {
  "value": "Мимолетно o/e",
  "id": "fleeting-oe",
  "level": 4
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    abbr: "abbr",
    code: "code",
    em: "em",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    header: "header",
    li: "li",
    p: "p",
    span: "span",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {CustomAfterSection, CustomBeforeSection, IPA, MDPhonology1, MDPhonology2, MDPhonology3, TransliteratorElement} = _components;
  if (!CustomAfterSection) _missingMdxReference("CustomAfterSection", true);
  if (!CustomBeforeSection) _missingMdxReference("CustomBeforeSection", true);
  if (!IPA) _missingMdxReference("IPA", true);
  if (!MDPhonology1) _missingMdxReference("MDPhonology1", true);
  if (!MDPhonology2) _missingMdxReference("MDPhonology2", true);
  if (!MDPhonology3) _missingMdxReference("MDPhonology3", true);
  if (!TransliteratorElement) _missingMdxReference("TransliteratorElement", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "фонология",
        children: "Фонология"
      })
    }), "\n", _jsx(_components.h2, {
      id: "phoneme-inventory",
      children: "Инвентаризация на фонемите"
    }), "\n", _jsx(CustomBeforeSection, {}), "\n", _jsx(_components.p, {
      children: "Междуславянският нито е национален език, нито се опитва да подражава на такъв.\nВместо това, той се основава на дванадесет национални езика, като всеки от тях има своя собствена фонология и собствена съответна ортография, пригодени да отговарят на специфичните му характеристики.\nКато цяло може да се каже, че колкото по на юг отивате, толкова по-малък става наборът от фонеми (звукове).\nИ говоримият, и писменият междуславянски трябва да бъде в самата им среда, доколкото е възможно."
    }), "\n", _jsxs(_components.p, {
      children: ["Големият брой фонеми прави интуитивното писане и произнасяне на междуславянски по-трудно за тези, които са свикнали с по-малко фонеми.\nНиското число, от друга страна, прави по-трудно свързването на определен знак или звук с фонема на собствения език и следователно има отрицателен ефект върху разбираемостта.\nНапример, идеалното произношение на думата за „пет” би било нещо като ", _jsx(IPA, {
        children: "pjætʲ"
      }), ".\nАко напишем това като ", _jsx(TransliteratorElement, {
        children: "pęť"
      }), ", руснакът лесно може да познае своя ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "ru",
        children: "пять"
      }), ", сърбинът своя ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "sr",
        children: "pet"
      }), " и полякът своя ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "pl",
        children: "pięć"
      }), "; но за един сърбин няма начин да разбере кога неговите собствени ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "e"
        })
      }), " и ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "t"
        })
      }), " стават ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ę"
        })
      }), " и ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "t́"
        })
      }), ", без да се консултира с речник.\nОт друга страна, в опростена схема ", _jsx(TransliteratorElement, {
        children: "pet"
      }), " може също да бъде погрешно разбран като руски ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "ru",
        children: "петь"
      }), " „да пея” или полски ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "pl",
        children: "pet"
      }), " „зад цигара”.\nНакратко: колкото по-лесно го правим за говорещия/пишещия, толкова по-трудно става за слушателя/четеца и обратното."]
    }), "\n", _jsxs(_components.p, {
      children: ["За да разреши тази дилема, Interslavic има основен набор от фонеми, които присъстват във всички или в по-голямата част от славянските езици, повече или по-малко с еднакви фонетични стойности.\nОсвен това междуславянският също има набор от незадължителни фонеми, които се свързват директно със старославянския и се отнасят до конкретни фонетични разлики между езиците.\nИзползвайки гореспоменатата дума ", _jsx(TransliteratorElement, {
        children: "pęť"
      }), " като пример, руският ", _jsx(IPA, {
        children: "pjætʲ"
      }), " и южнославянският ", _jsx(IPA, {
        children: "pɛt"
      }), " са просто два начина за произнасяне на една и съща дума: буквите ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ę"
        })
      }), " и ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "t́"
        })
      }), " показват, че тяхното произношение варира в различните езици.\nТези допълнителни фонеми могат да бъдат написани с помощта на допълнителен набор от незадължителни букви, част от ", _jsx(_components.a, {
        href: "/bg/learn/orthography#etymological-alphabet",
        children: "Междуславянската етимологична азбука"
      }), " (преди известна като ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.em, {
          children: "Naučny Medžuslovjansky"
        })
      }), ")."]
    }), "\n", _jsx(_components.p, {
      children: "Следните диаграми дават общ преглед на фонемите в междуславянския въз основа на най-средното им произношение.\nОсновните фонеми са показани в черно, вариантите по избор в сиво."
    }), "\n", _jsx(_components.h2, {
      id: "vowels",
      children: "Гласни"
    }), "\n", _jsxs(_components.p, {
      children: ["Основният междуславянски има 7 гласни фонеми, пет от които (", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "a"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "e"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "i"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "o"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "u"
        })
      }), ") имат доста еднакво произношение, докато останалите две (", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ě"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "y"
        })
      }), ") имат произношение, което може да се различава между говорещите."]
    }), "\n", _jsxs(_components.p, {
      children: ["Освен това има 5 незадължителни гласни (", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "å"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ė"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ę"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ȯ"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ų"
        })
      }), "), чието произношение може да варира.\nДиакритичните знаци обикновено не се изписват.\nВ ароматизираните версии на Interslavic обаче ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "å"
        })
      }), " може да се напише и произнесе като ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "o"
        })
      }), ", ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ę"
        })
      }), " като ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ja"
        })
      }), ", ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ȯ"
        })
      }), " като ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "e"
        })
      }), " и ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "y"
        })
      }), " като ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "i"
        })
      }), "."]
    }), "\n", _jsx(MDPhonology1, {}), "\n", _jsxs(_components.p, {
      children: ["Междуславянският също има сричкови ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "r"
        })
      }), " и ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ŕ"
        })
      }), " (последният принадлежи към незадължителния набор).\nТакъв е случаят, когато е предшествано от съгласна и ", _jsx(_components.em, {
        children: "не"
      }), " последвано от гласна.\nПроизнася се със schwa преди него: ", _jsx(TransliteratorElement, {
        children: "trg"
      }), " ", _jsx(IPA, {
        children: "tərg"
      }), ", ", _jsx(TransliteratorElement, {
        children: "mŕtvy"
      }), " ", _jsx(IPA, {
        children: "mjərtvɪ"
      }), ", ", _jsx(TransliteratorElement, {
        children: "cukr"
      }), " ", _jsx(IPA, {
        children: "ʦukər"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "consonants",
      children: "съгласни"
    }), "\n", _jsx(_components.p, {
      children: "Има 23 основни съгласни (включително 3 африкати и 2 палатализирани алвеоларни) с повече или по-малко фиксирано произношение, както и 7 незадължителни съгласни с променливо произношение:"
    }), "\n", _jsx(MDPhonology2, {}), "\n", _jsx(_components.h2, {
      id: "hard-and-soft-consonants",
      children: "Твърди и меки съгласни"
    }), "\n", _jsxs(_components.p, {
      children: ["Както всички славянски езици, междуславянският прави разлика между ", _jsx(_components.em, {
        children: "твърди"
      }), " и ", _jsx(_components.em, {
        children: "меки"
      }), " съгласни:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Твърдите съгласни са: лабиалните ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "p"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "b"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "f"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "v"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "m"
          })
        }), ", твърдите дентални/алвеоларни ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "t"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "d"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "s"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "z"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "n"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "r"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "l"
          })
        }), ", и веларните ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "k"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "g"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "h"
          })
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Меките съгласни са: посталвеоларните ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "š"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ž"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "č"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "dž"
          })
        }), ", меките дентални/алвеоларни ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "lj"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "nj"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ŕ"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "t́"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "d́"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ś"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ź"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ć"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "đ"
          })
        }), ", и палаталният апроксимант ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "j"
          })
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Африката ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "c"
          })
        }), " ", _jsx(IPA, {
          children: "t͡s"
        }), " се произнася трудно, но в граматиката се държи като мека съгласна. Неговият звучен аналог ", _jsx(IPA, {
          children: "d͡z"
        }), " не се среща в междуславянския."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Омекотяването е процес на добавяне на ", _jsx(IPA, {
        children: "ʲ"
      }), " към съгласна, което води до по-палатално произношение.\nБроят на меките еквиваленти на твърдите съгласни в описа на фонемите варира значително от един език на друг.\nВ междуславянския само ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "lj"
        })
      }), " и ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "nj"
        })
      }), " са задължителни, етимологичната азбука също има ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "t́"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "d́"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ś"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ź"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ŕ"
        })
      }), " (обикновено се пише ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "t"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "d"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "s"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "z"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "r"
        })
      }), "): острото ударение замества кирилицата ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "sla",
        children: _jsx(_components.code, {
          children: "ь"
        })
      }), ", която днес се използва като омекотител, но преди е била гласна в старите дни: ултракъса ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "sla",
        children: _jsx(_components.code, {
          children: "ĭ"
        })
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "Както може да се види от таблицата по-горе, произношението на меките съгласни е различно.\nИзточнославянските говорещи вероятно ще ги произнасят като смекчени зъбни или алвеоларни съгласни, западнославянските говорещи по-скоро като палатални съгласни.\nИ двете произношения са еднакво правилни, въпреки че първото вероятно е по-лесно за разбиране от южните славяни."
    }), "\n", _jsxs(_components.p, {
      children: ["Меките съгласни също включват посталвеоларни ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "š"
        })
      }), ", ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ž"
        })
      }), ", ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "č"
        })
      }), " и ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "dž"
        })
      }), ", както и африкатите ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ć"
        })
      }), " и ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "đ"
        })
      }), ".\nПоследните две обикновено се пишат и произнасят също ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "č"
        })
      }), " и ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "dž"
        })
      }), "; разликата е от етимологично естество: ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ć"
        })
      }), " и ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "đ"
        })
      }), " са йотираните двойници на ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "t"
        })
      }), " и ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "d"
        })
      }), " (виж по-долу)."]
    }), "\n", _jsxs(_components.p, {
      children: ["Преди ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "i"
        })
      }), ", ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ě"
        })
      }), ", ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ę"
        })
      }), ", ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ė"
        })
      }), " и ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ŕ"
        })
      }), " твърдата съгласна може да бъде омекотена или палатализирана.\nЕто защо дума като ", _jsx(TransliteratorElement, {
        children: "buditi"
      }), " се произнася или ", _jsx(IPA, {
        children: "buditi"
      }), ", ", _jsx(IPA, {
        children: "budʲitʲi"
      }), " , или ", _jsx(IPA, {
        children: "buɟici"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "phonotactics",
      children: "Фонотактика"
    }), "\n", _jsxs(_components.p, {
      children: ["Междуславянската ортография се основава на етимологията, а не на произношението, така че могат да възникнат групи от съгласни, които може да изглеждат непроизносими за англоговорящите, например ", _jsx(TransliteratorElement, {
        children: "vozvršenje"
      }), ".\nЕдинствените ограничения са свързани с комбинирането на определени гласни с определени съгласни."]
    }), "\n", _jsx(_components.p, {
      children: "Важно е да знаете следното:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Всяка сричка съдържа една от следните гласни: ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "a"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "å"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "e"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ę"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ė"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ě"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "i"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "o"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ȯ"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "u"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ų"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "y"
          })
        }), " или сричкова ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "r"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ŕ"
          })
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "å"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ę"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ė"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ě"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ȯ"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ų"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "y"
          })
        }), " и сричкови ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "r"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ŕ"
          })
        }), ": никога не се появява дума в началото или след гласна"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "y"
          })
        }), ": никога не може да следва мека съгласна"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ě"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ŕ"
          })
        }), ": винаги следва твърда съгласна или ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "c"
          })
        }), " (те са излишни в случаи като ", _jsx(TransliteratorElement, {
          children: "jěsti"
        }), " и ", _jsx(TransliteratorElement, {
          children: "čŕny"
        }), "), но могат да бъдат произнесени по такъв начин, че да я омекотят"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "o"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ȯ"
          })
        }), ": рядко следва мека съгласна, освен в заемки като ", _jsx(TransliteratorElement, {
          children: "majonez"
        }), " и ", _jsx(TransliteratorElement, {
          children: "čokolada"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "å"
          })
        }), " винаги се предшества от течност (", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "r"
          })
        }), " или ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "l"
          })
        }), ") и последвано от съгласна"]
      }), "\n", _jsxs(_components.li, {
        children: ["геминативните съгласни се срещат само в резултат на префикс (", _jsx(TransliteratorElement, {
          children: "od-dati"
        }), ", ", _jsx(TransliteratorElement, {
          children: "v-voz"
        }), ") или суфикс (", _jsx(TransliteratorElement, {
          children: "kon-ny"
        }), ", ", _jsx(TransliteratorElement, {
          children: "rus-sky"
        }), "), в редки случаи в заемки (", _jsx(TransliteratorElement, {
          children: "motto"
        }), ")."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "morphophonemic-alternations",
      children: "Морфофонемични редувания"
    }), "\n", _jsx(_components.p, {
      children: "Инфлексията се поддържа възможно най-правилна.\nВъпреки това, редувания като палатализация и йотизация на съгласни са вездесъщо явление в славянския език.\nТе играят решаваща роля както в словоизменението, така и в процеса на изграждане на думата и следователно не могат да бъдат избегнати дори в най-опростената форма на междуславянски – поне ако искаме да избегнем форми, които изглеждат силно изкуствени и неестествени."
    }), "\n", _jsx(_components.h3, {
      id: "palatalisation",
      children: "Палатализация"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.em, {
        children: "Палатализация"
      }), " означава, че при определени условия веларните съгласни ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "k"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "g"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "h"
        })
      }), " (както и зъбната африката ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "c"
        })
      }), ") се променят на посталвеоларните съгласни ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "č"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ž"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "š"
        })
      }), ".\nТова се случва в следните случаи:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["пред ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "-e"
          })
        }), " в звателен падеж единствено число на съществителни от мъжки род: ", _jsxs(TransliteratorElement, {
          children: ["Bo", _jsx(_components.strong, {
            children: "g"
          })]
        }), " „Бог” > ", _jsxs(TransliteratorElement, {
          children: ["Bo", _jsx(_components.strong, {
            children: "ž"
          }), "e"]
        }), ", ", _jsxs(TransliteratorElement, {
          children: ["hlåpė", _jsx(_components.strong, {
            children: "c"
          })]
        }), " „момче” > ", _jsxs(TransliteratorElement, {
          children: ["hlåp", _jsx(_components.strong, {
            children: "č"
          }), "e"]
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["пред ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "-e"
          })
        }), ", ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "-eš"
          })
        }), " и т.н. в сегашно време на глаголи: ", _jsxs(TransliteratorElement, {
          children: ["pe", _jsx(_components.strong, {
            children: "k"
          }), "-ti"]
        }), " „да пека” > ", _jsxs(TransliteratorElement, {
          children: ["pe", _jsx(_components.strong, {
            children: "č"
          }), "eš"]
        }), ", ", _jsxs(TransliteratorElement, {
          children: ["mo", _jsx(_components.strong, {
            children: "g"
          }), "-ti"]
        }), " „може” > ", _jsxs(TransliteratorElement, {
          children: ["mo", _jsx(_components.strong, {
            children: "ž"
          }), "eš"]
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["преди ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "-i-"
          })
        }), " в производни глаголи: ", _jsx(TransliteratorElement, {
          children: "muka"
        }), " „мъча” > ", _jsxs(TransliteratorElement, {
          children: ["mu", _jsx(_components.strong, {
            children: "č"
          }), "iti"]
        }), " „мъча”, ", _jsxs(TransliteratorElement, {
          children: ["slu", _jsx(_components.strong, {
            children: "g"
          }), "a"]
        }), " „слуга” > ", _jsxs(TransliteratorElement, {
          children: ["slu", _jsx(_components.strong, {
            children: "ž"
          }), "iti"]
        }), " „служа”"]
      }), "\n", _jsxs(_components.li, {
        children: ["преди наставките ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "-an(in)"
          })
        }), ", ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "-ba"
          })
        }), ", ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "-ec"
          })
        }), ", ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "-ica"
          })
        }), ", ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "-ina"
          })
        }), ", ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "-išče"
          })
        }), ", ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "-je"
          })
        }), ", ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "-ji"
          })
        }), ", ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "-nik"
          })
        }), ", ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "-ny"
          })
        }), ", ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "-ok"
          })
        }), "/", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "-ka"
          })
        }), "/", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "-ko"
          })
        }), ", ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "-sky"
          })
        }), ", ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "-stvo"
          })
        }), ", и т.н.: ", _jsxs(TransliteratorElement, {
          children: ["rų", _jsx(_components.strong, {
            children: "k"
          }), "a"]
        }), " „ръка” > ", _jsxs(TransliteratorElement, {
          children: ["rų", _jsx(_components.strong, {
            children: "č"
          }), "ny"]
        }), " „ръчно”, ", _jsxs(TransliteratorElement, {
          children: ["mu", _jsx(_components.strong, {
            children: "h"
          }), "a"]
        }), " „муха” > ", _jsxs(TransliteratorElement, {
          children: ["mu", _jsx(_components.strong, {
            children: "š"
          }), "ka"]
        }), " „малка муха”"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Освен гореспоменатия вокатив, палатализацията никога не се среща в склонението на съществителни, прилагателни и местоимения.\nТака: ", _jsx(_components.abbr, {
        title: "единствено число",
        children: "ед.ч."
      }), " ", _jsx(TransliteratorElement, {
        children: "Čeh"
      }), " „чехи” > ", _jsx(_components.abbr, {
        title: "множествено число",
        children: "мн.ч."
      }), " ", _jsx(TransliteratorElement, {
        children: "Čehi"
      }), " „чехи”; ", _jsx(_components.abbr, {
        title: "единствено число",
        children: "ед.ч."
      }), " ", _jsx(TransliteratorElement, {
        children: "dȯlgy"
      }), " „дълъг” > ", _jsx(_components.abbr, {
        title: "множествено число",
        children: "мн.ч."
      }), " ", _jsx(TransliteratorElement, {
        children: "dȯlgi"
      }), " (одушевен) или ", _jsx(TransliteratorElement, {
        children: "dȯlge"
      }), " (неодушевен)."]
    }), "\n", _jsx(_components.h3, {
      id: "iotation",
      children: "Йотация"
    }), "\n", _jsxs(_components.p, {
      children: ["Друго нещо се случва, когато ", _jsx(_components.em, {
        children: "твърда съгласна"
      }), " е последвана от ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "j"
        })
      }), ".\nРезултатът се нарича ", _jsx(_components.em, {
        children: "iotation"
      }), ", което не е същото като омекотяване.\nМоделите, според които съгласните взаимодействат с този ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "j"
        })
      }), ", варират от един език на друг.\nПонякога резултатът е същият като в случай на омекотена съгласна, понякога е различен:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Лабиалните ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "p"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "b"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "m"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "f"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "v"
          })
        }), " винаги са твърди. Преди ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "j"
          })
        }), " източно- и южнославянските вмъкват ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "l"
          })
        }), " (", _jsxs(TransliteratorElement, {
          children: ["kup", _jsx(_components.strong, {
            children: "l"
          }), "ju"]
        }), ", ", _jsxs(TransliteratorElement, {
          children: ["sostav", _jsx(_components.strong, {
            children: "l"
          }), "jenie"]
        }), "), но в междуславянските просто пишем ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "pj"
          })
        }), ", ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "vj"
          })
        }), " и т.н., както от съображения за яснота, така и за редовност."]
      }), "\n", _jsxs(_components.li, {
        children: ["Веларите ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "k"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "g"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "h"
          })
        }), ", , последвани от ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "j"
          })
        }), ", се превръщат в палатал в ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "č"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ž"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "š"
          })
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["В случай на ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "l"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "n"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "r"
          })
        }), ", йотирането дава същия резултат като омекотяването: ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "lj"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "nj"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "rj"
          })
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Комбинациите ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "s"
          })
        }), "+", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "j"
          })
        }), " и ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "z"
          })
        }), "+", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "j"
          })
        }), " стават ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "š"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ž"
          })
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Комбинациите ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "t"
          })
        }), "+", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "j"
          })
        }), " и ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "d"
          })
        }), "+", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "j"
          })
        }), " стават ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ć"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "đ"
          })
        }), " (обикновено се изписва ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "č"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "dž"
          })
        }), ")."]
      }), "\n", _jsxs(_components.li, {
        children: ["В последователностите ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "sk"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "st"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "zg"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "zd"
          })
        }), ", ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "s"
          })
        }), " и ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "z"
          })
        }), " се йотират заедно със следната съгласна, по този начин: ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "st"
          })
        }), "+", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "j"
          })
        }), " > ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "šć"
          })
        }), " и т.н."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Йотацията се среща най-вече в глаголите от клас ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "-i-"
        })
      }), ":"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["в първо лице единствено число: ", _jsxs(TransliteratorElement, {
          children: ["pro", _jsx(_components.strong, {
            children: "s"
          }), "-iti"]
        }), " > ", _jsxs(TransliteratorElement, {
          children: ["pro", _jsx(_components.strong, {
            children: "s"
          }), "-jų"]
        }), " > ", _jsxs(TransliteratorElement, {
          children: ["pro", _jsx(_components.strong, {
            children: "š"
          }), "ų"]
        }), " (обикновено се пише ", _jsxs(TransliteratorElement, {
          children: ["pro", _jsx(_components.strong, {
            children: "š"
          }), "u"]
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["в перфектния страдателен залог: ", _jsxs(TransliteratorElement, {
          children: ["tra", _jsx(_components.strong, {
            children: "t"
          }), "-iti"]
        }), "> ", _jsxs(TransliteratorElement, {
          children: ["tra", _jsx(_components.strong, {
            children: "t"
          }), "-jeny"]
        }), " > ", _jsxs(TransliteratorElement, {
          children: ["tra", _jsx(_components.strong, {
            children: "ć"
          }), "eny"]
        }), " (обикновено се пише ", _jsxs(TransliteratorElement, {
          children: ["tra", _jsx(_components.strong, {
            children: "č"
          }), "eny"]
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["в случай на глаголи от несвършен вид, получени от глаголи от свършен вид на ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "-iti"
          })
        }), ": ", _jsxs(TransliteratorElement, {
          children: ["nagrå", _jsx(_components.strong, {
            children: "d"
          }), "-iti"]
        }), " > ", _jsxs(TransliteratorElement, {
          children: ["nagra", _jsx(_components.strong, {
            children: "d"
          }), "-jati"]
        }), " > ", _jsxs(TransliteratorElement, {
          children: ["nagra", _jsx(_components.strong, {
            children: "đ"
          }), "ati"]
        }), " (обикновено се пише ", _jsxs(TransliteratorElement, {
          children: ["nagra", _jsx(_components.strong, {
            children: "dž"
          }), "ati"]
        }), ")"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Йотация не възниква, когато дума с начален ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "j"
        })
      }), " е предшествана от префикс: ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "s"
        })
      }), "+", _jsx(TransliteratorElement, {
        children: "jesti"
      }), " става ", _jsxs(TransliteratorElement, {
        children: [_jsx(_components.strong, {
          children: "sj"
        }), "esti"]
      }), ", а не ", _jsx(TransliteratorElement, {
        children: "šesti"
      }), "."]
    }), "\n", _jsx(_components.h3, {
      id: "palatalisation--iotation",
      children: "Палатализация + йотация"
    }), "\n", _jsxs(_components.p, {
      children: ["Когато ", _jsx(_components.em, {
        children: "мека съгласна"
      }), " е последвана от ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "j"
        })
      }), ", както съгласната, така и плъзгането остават недокоснати.\nВсички промени се блокират от омекотителя, така да се каже.\nВ етимологичната ортография ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ljj"
        })
      }), ", ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "njj"
        })
      }), " и т.н. се записват като ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ľj"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ńj"
        })
      }), ", , за да се избегне геминацията на ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "j"
        })
      }), ".\nПо същия начин пишем и ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ŕj"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "t́j"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "d́j"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "śj"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "źj"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "šj"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "žj"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "čj"
        })
      }), " .\nВ стандартната ортография ние просто пишем ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "lj"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "nj"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "rj"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "tj"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "dj"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "sj"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "zj"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "šj"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "žj"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "čj"
        })
      }), " в тези случаи.\nАко основата завършва на ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "-j"
        })
      }), ", следният ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "j-"
        })
      }), " просто се поглъща: ", _jsxs(TransliteratorElement, {
        children: ["dvo", _jsx(_components.strong, {
          children: "j"
        }), "-iti"]
      }), " > ", _jsxs(TransliteratorElement, {
        children: ["dvo", _jsx(_components.strong, {
          children: "j-j"
        }), "ų"]
      }), " > ", _jsxs(TransliteratorElement, {
        children: ["dvo", _jsx(_components.strong, {
          children: "j"
        }), "ų"]
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "Това се случва в следните ситуации:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["с палатализиращ суфикс ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "-’je"
          })
        }), " (указващ място, например): ", _jsx(TransliteratorElement, {
          children: "morje"
        }), "> ", _jsx(TransliteratorElement, {
          children: "pri+mor+’je"
        }), " > ", _jsx(TransliteratorElement, {
          children: "primoŕje"
        }), " (обикновено се изписва ", _jsx(TransliteratorElement, {
          children: "primorje"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["при отглаголни съществителни, където окончанието ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "-y"
          })
        }), " на перфектния страдателен залог се заменя с (палатализиращо) ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "-’je"
          })
        }), ": ", _jsx(TransliteratorElement, {
          children: "dělati"
        }), " > ", _jsx(TransliteratorElement, {
          children: "dělańje"
        }), " (обикновено се пише ", _jsx(TransliteratorElement, {
          children: "dělanje"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["с палатализираща притежателна наставка ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "-ji"
          })
        }), ": ", _jsx(TransliteratorElement, {
          children: "Bog"
        }), " + ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "’ji"
          })
        }), " > ", _jsxs(TransliteratorElement, {
          children: ["Bo", _jsx(_components.strong, {
            children: "ž"
          }), "ji_"]
        }), ", ", _jsx(TransliteratorElement, {
          children: "kot"
        }), " + ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "’ji"
          })
        }), " > ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "kot́ji"
          })
        }), " (обикновено се изписва ", _jsx(TransliteratorElement, {
          children: "kotji"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["в инструментален падеж единствено число на съществителни от типа ", _jsx(TransliteratorElement, {
          children: "kost"
        }), ": ", _jsx(TransliteratorElement, {
          children: "kost"
        }), " + ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "’jų"
          })
        }), " > ", _jsx(TransliteratorElement, {
          children: "kosťjų"
        }), " (обикновено се изписва ", _jsx(TransliteratorElement, {
          children: "kostju"
        }), ")"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Колкото и сложно да изглежда това, всичко това означава в писмен вид е, че суфиксите ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "-je"
        })
      }), ", ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "-ji"
        })
      }), " и инструменталното окончание ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "-jų"
        })
      }), " не причиняват йотация, а само палатализация на ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "k"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "g"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "h"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "c"
        })
      }), "."]
    }), "\n", _jsx(_components.h4, {
      id: "overview",
      children: "Общ преглед"
    }), "\n", _jsx(_components.p, {
      children: "Разликите между смекчени, патализирани и йотирани съгласни са показани в следната таблица (отново фонемите в сиво не са задължителни):"
    }), "\n", _jsx(MDPhonology3, {}), "\n", _jsxs(_components.h3, {
      id: "o--e",
      children: [_jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "O"
        })
      }), " > ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "E"
        })
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["Старославянският е имал особена непоносимост към ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "o"
        })
      }), " след мека съгласна и винаги, когато се е случвало такава последователност поради окончание или наставка, ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "o"
        })
      }), " се е променяло на ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "e"
        })
      }), ".\nТова развитие е оставило своите белези във всички славянски езици, въпреки че днес те се различават по отношение на степента, в която все още се прилага.\nНапример, в руския мек съгласен + ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "o"
        })
      }), " последователностите са рядкост, докато полският има само някои лексикални остатъци от правилото (напр. ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "pl",
        children: "królewski"
      }), " „кралски”, но: ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "pl",
        children: "królowa"
      }), " „кралица”)."]
    }), "\n", _jsxs(_components.p, {
      children: ["Това правило важи и в междуславянския.\nТака окончания като ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "-o"
        })
      }), ", ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "-ov"
        })
      }), ", ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "-om"
        })
      }), ", ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "-ogo"
        })
      }), " и ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "-oj"
        })
      }), " стават ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "-e"
        })
      }), ", ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "-ev"
        })
      }), ", ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "-em"
        })
      }), ", ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "-ego"
        })
      }), " и ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "-ej"
        })
      }), " след мека съгласна.\nПоради правилото ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "o"
        })
      }), "/", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "e"
        })
      }), " имаме ", _jsx(TransliteratorElement, {
        children: "morje"
      }), " срещу ", _jsx(TransliteratorElement, {
        children: "okno"
      }), ", ", _jsx(TransliteratorElement, {
        children: "krajev"
      }), " срещу ", _jsx(TransliteratorElement, {
        children: "gradov"
      }), " и ", _jsx(TransliteratorElement, {
        children: "čego"
      }), " срещу ", _jsx(TransliteratorElement, {
        children: "kogo"
      }), ".\nСъщият механизъм работи и в комбинация с наставки като ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "-ost"
        })
      }), ", ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "-ovati"
        })
      }), " и ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "-ovy"
        })
      }), ", например: ", _jsx(TransliteratorElement, {
        children: "svěžesť"
      }), ", ", _jsx(TransliteratorElement, {
        children: "nočevati"
      }), "."]
    }), "\n", _jsxs(_components.h4, {
      id: "y--ie",
      children: [_jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "Y"
        })
      }), " > ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "I"
        })
      }), "/", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "E"
        })
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["В южнославянски и украински, както и в говорими чешки и словашки, ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "i"
        })
      }), " и ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "y"
        })
      }), " са се слели в една гласна.\nСледователно в междуславянския произношението на ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "y"
        })
      }), " може да бъде ", _jsx(IPA, {
        children: "i"
      }), ", ", _jsx(IPA, {
        children: "ɪ"
      }), ", ", _jsx(IPA, {
        children: "ɨ"
      }), " или нещо по средата.\nВажното обаче е, че ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "y"
        })
      }), " може да се появи ", _jsx(_components.em, {
        children: "само"
      }), " след твърда съгласна и следователно не след мека съгласна (", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "š"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ž"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "č"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "dž"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "c"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "lj"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "nj"
        })
      }), " ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "j"
        })
      }), "), след гласна или дума - първоначално.\nТъй като ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "y"
        })
      }), " играе важна роля в междуславянската флексия, повечето склонения имат твърда и мека версия поради това ограничение."]
    }), "\n", _jsxs(_components.p, {
      children: ["При склонението на прилагателни и местоимения падежните окончания на ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "y"
        })
      }), " стават ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "i"
        })
      }), " след мека съгласна.\nПоради тази причина имаме прилагателни като ", _jsxs(TransliteratorElement, {
        children: ["svěž-", _jsx(_components.strong, {
          children: "i"
        })]
      }), " заедно с прилагателни като ", _jsxs(TransliteratorElement, {
        children: ["dobr-", _jsx(_components.strong, {
          children: "y"
        })]
      }), " и местоименни форми като ", _jsxs(TransliteratorElement, {
        children: ["moj-", _jsx(_components.strong, {
          children: "ih"
        })]
      }), " заедно с форми като ", _jsxs(TransliteratorElement, {
        children: ["jegov-", _jsx(_components.strong, {
          children: "yh"
        })]
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["В съществителното склонение обаче мекият аналог на ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "y"
        })
      }), " винаги е ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "e"
        })
      }), ".\nНапример: ", _jsx(_components.abbr, {
        title: "мъжки род, множествено число",
        children: "м.р. мн.ч."
      }), " ", _jsxs(TransliteratorElement, {
        children: ["dom-", _jsx(_components.strong, {
          children: "y"
        })]
      }), " срещу ", _jsxs(TransliteratorElement, {
        children: ["kraj-", _jsx(_components.strong, {
          children: "e"
        })]
      }), ", ", _jsx(_components.abbr, {
        title: "женски род, множествено число",
        children: "ж.р. мн.ч."
      }), " ", _jsxs(TransliteratorElement, {
        children: ["žen-", _jsx(_components.strong, {
          children: "y"
        })]
      }), " срещу ", _jsxs(TransliteratorElement, {
        children: ["zemj-", _jsx(_components.strong, {
          children: "e"
        })]
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Тъй като няколко славянски езика изобщо не правят разлика между ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "i"
        })
      }), " и ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "y"
        })
      }), ", заместването на всички срещания на ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "y"
        })
      }), " с ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "i"
        })
      }), " е приемливо опростяване в писмения междуславянски."]
    }), "\n", _jsx(_components.h4, {
      id: "ě--i",
      children: _jsx(_components.code, {
        children: "Ě > I"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Точно като ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "y"
        })
      }), ", фонемата ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ě"
        })
      }), " винаги следва твърда съгласна.\nВ дателен и местен падеж единствено число на съществителни от женски род става i след мека съгласна, т.е. следва модел, противоположен на ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "y"
        })
      }), " > ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "e"
        })
      }), ": ", _jsxs(TransliteratorElement, {
        children: ["žen-", _jsx(_components.strong, {
          children: "ě"
        })]
      }), ", но ", _jsxs(TransliteratorElement, {
        children: ["zemj-", _jsx(_components.strong, {
          children: "i"
        })]
      }), "."]
    }), "\n", _jsxs(_components.h4, {
      id: "fleeting-oe",
      children: ["Мимолетно ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "o"
        })
      }), "/", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "e"
        })
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["Характерна черта на славянските езици е съществуването на „мимолетни“ или „подвижни“ гласни, отнасящи се до явлението гласни, появяващи се и изчезващи по привидно случаен начин, особено в определени склонени форми на съществителни.\nТова е резултат от различни рефлекси на общославянските джерси ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "sla",
        children: _jsx(_components.code, {
          children: "ъ"
        })
      }), " и ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "sla",
        children: _jsx(_components.code, {
          children: "ь"
        })
      }), ", които се губят в слаби позиции и се вокализират в ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "o"
        })
      }), " и ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "e"
        })
      }), " в силни позиции.\nВ повечето случаи тази гласна се появява в думи, които иначе биха завършвали на група съгласни, и изчезва, когато тази група е последвана от окончание."]
    }), "\n", _jsxs(_components.p, {
      children: ["Мимолетните ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "o"
        })
      }), " и ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "e"
        })
      }), " (в етимологичната азбука, отбелязани с точка: ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ȯ"
        })
      }), " и ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ė"
        })
      }), ") се появяват особено в следните случаи:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["в именителен падеж (и, в случай на неодушевени съществителни, във винителен падеж) единствено число на съществителни от мъжки род, особено тези, завършващи на ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "-ec"
          })
        }), " и ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "-ok"
          })
        }), ", както и няколко други съществителни:\n", _jsx(_components.abbr, {
          title: "именителен падеж, единствено число",
          children: "им.ед.ч."
        }), " ", _jsxs(TransliteratorElement, {
          children: ["ot", _jsx(_components.strong, {
            children: "ė"
          }), "c"]
        }), " „баща” > ", _jsx(_components.abbr, {
          title: "родителен падеж, единствено число",
          children: "р.ед.ч."
        }), " ", _jsx(TransliteratorElement, {
          children: "otca"
        }), "\n", _jsx(_components.abbr, {
          title: "именителен падеж, единствено число",
          children: "им.ед.ч."
        }), " ", _jsxs(TransliteratorElement, {
          children: ["pěs", _jsx(_components.strong, {
            children: "ȯ"
          }), "k"]
        }), " „пясък” > ", _jsx(_components.abbr, {
          title: "родителен падеж, единствено число",
          children: "р.ед.ч."
        }), " ", _jsx(TransliteratorElement, {
          children: "pěska"
        }), "\n", _jsx(_components.abbr, {
          title: "именителен падеж, единствено число",
          children: "им.ед.ч."
        }), " ", _jsxs(TransliteratorElement, {
          children: ["p", _jsx(_components.strong, {
            children: "ė"
          }), "s"]
        }), " „куче” > ", _jsx(_components.abbr, {
          title: "родителен падеж, единствено число",
          children: "р.ед.ч."
        }), " ", _jsx(TransliteratorElement, {
          children: "psa"
        }), "\n", _jsx(_components.abbr, {
          title: "именителен падеж, единствено число",
          children: "им.ед.ч."
        }), " ", _jsxs(TransliteratorElement, {
          children: ["s", _jsx(_components.strong, {
            children: "ȯ"
          }), "n"]
        }), " „мечта” > ", _jsx(_components.abbr, {
          title: "родителен падеж, единствено число",
          children: "р.ед.ч."
        }), " ", _jsx(TransliteratorElement, {
          children: "sna"
        }), "\n", _jsx(_components.abbr, {
          title: "именителен падеж, единствено число",
          children: "им.ед.ч."
        }), " ", _jsxs(TransliteratorElement, {
          children: ["kr", _jsx(_components.strong, {
            children: "ȯ"
          }), "v"]
        }), " „кръв” > ", _jsx(_components.abbr, {
          title: "родителен падеж, единствено число",
          children: "р.ед.ч."
        }), " ", _jsx(TransliteratorElement, {
          children: "krvi"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["в родителен падеж на съществителни от женски и среден род, които иначе биха завършвали на група съгласни:\n", _jsx(_components.abbr, {
          title: "именителен падеж, единствено число",
          children: "им.ед.ч."
        }), " ", _jsx(TransliteratorElement, {
          children: "okno"
        }), " „прозорец” > ", _jsx(_components.abbr, {
          title: "родителен падеж, множествено число",
          children: "р.мн.ч."
        }), " ", _jsxs(TransliteratorElement, {
          children: ["ok", _jsx(_components.strong, {
            children: "ė"
          }), "n"]
        }), "\n", _jsx(_components.abbr, {
          title: "именителен падеж, единствено число",
          children: "им.ед.ч."
        }), " ", _jsx(TransliteratorElement, {
          children: "miska"
        }), " „купа” > ", _jsx(_components.abbr, {
          title: "родителен падеж, множествено число",
          children: "р.мн.ч."
        }), " ", _jsxs(TransliteratorElement, {
          children: ["mis", _jsx(_components.strong, {
            children: "ȯ"
          }), "k"]
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["в именителния падеж единствено число на определени местоимения:\n", _jsx(_components.abbr, {
          title: "мъжки род, именителен падеж, единствено число",
          children: "м.р. им. ед.ч."
        }), " ", _jsxs(TransliteratorElement, {
          children: ["v", _jsx(_components.strong, {
            children: "ė"
          }), "ś"]
        }), " „всичко, цялото”, ", _jsx(_components.abbr, {
          title: "женски род, именителен падеж, единствено число",
          children: "ж.р. им. ед.ч."
        }), " ", _jsx(TransliteratorElement, {
          children: "vśa"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["пред определени наставки:\n", _jsx(TransliteratorElement, {
          children: "piśmo"
        }), " „писмо, скрипт” > ", _jsxs(TransliteratorElement, {
          children: ["pis", _jsx(_components.strong, {
            children: "ė"
          }), "mny"]
        }), " „написано, писмено”"]
      }), "\n", _jsxs(_components.li, {
        children: ["предлозите ", _jsx(TransliteratorElement, {
          children: "s"
        }), " и ", _jsx(TransliteratorElement, {
          children: "v"
        }), ", когато предхождат определени местоимения или групи съгласни, или когато се използват като префикс преди група гласна или съгласна:\n", _jsx(_components.em, {
          children: _jsx(TransliteratorElement, {
            children: _jsx(_components.code, {
              children: "s"
            })
          })
        }), " „с” + ", _jsx(TransliteratorElement, {
          children: "mnojų"
        }), " „аз” (", _jsx(_components.abbr, {
          title: "дателен падеж, единствено число",
          children: "д.ед.ч."
        }), ") > ", _jsxs(TransliteratorElement, {
          children: ["s", _jsx(_components.strong, {
            children: "ȯ"
          }), " mnojų"]
        }), ",\n", _jsx(_components.em, {
          children: _jsx(TransliteratorElement, {
            children: _jsx(_components.code, {
              children: "v"
            })
          })
        }), " „в” + ", _jsx(TransliteratorElement, {
          children: "vsih"
        }), " „всички” (", _jsx(_components.abbr, {
          title: "местен падеж, множествено число",
          children: "м.мн.ч."
        }), ") > ", _jsxs(TransliteratorElement, {
          children: ["v", _jsx(_components.strong, {
            children: "ȯ"
          }), " vsih"]
        }), ",\n", _jsx(_components.em, {
          children: _jsx(TransliteratorElement, {
            children: _jsx(_components.code, {
              children: "s-"
            })
          })
        }), " + ", _jsx(TransliteratorElement, {
          children: "držati"
        }), " > ", _jsxs(TransliteratorElement, {
          children: ["s", _jsx(_components.strong, {
            children: "ȯ"
          }), "držati"]
        }), " „да съдържа”,\n", _jsx(_components.em, {
          children: _jsx(TransliteratorElement, {
            children: _jsx(_components.code, {
              children: "v-"
            })
          })
        }), " + ", _jsx(TransliteratorElement, {
          children: "idti"
        }), " > ", _jsxs(TransliteratorElement, {
          children: ["v", _jsx(_components.strong, {
            children: "ȯ"
          }), "jdti"]
        }), " „за влизане“."]
      }), "\n"]
    }), "\n", _jsx(CustomAfterSection, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

